export const DIALING_CODE = '+91';

export const NAVIGATION_ROUTES = {
  SPLASH: '/',
  SIGNIN: '/signin',
  OTP: '/otp',
  HOME: '/home',
  REFER: '/refer',
  DOWNLOAD: '/download',
  HELP: '/help',
  FAQS:'/faqs',
  GAMEHISTORY: '/game-history',
  TOURNAMENTDETAILS: '/tournament-details',
  GAMEPLAY: '/game-play',
  WINNER_SCREEN: '/result',
  HOW_TO_PLAY: '/how-to-play',
  EXTERNAL_LINKS: '/external-links',
  WALLET: '/wallet',
  WITHDRAW: '/withdraw',
  WITHDRAW_STATUS: '/withdraw/status',
  WITHDRAW_ADD_MODE: '/withdraw/add-mode',
  WITHDRAW_MODES: '/withdraw/modes',
  KYC: '/kyc',
  /** Where SurePass returns the browser. Mirrored in public/kyc-callback.html. */
  KYC_CALLBACK: '/kyc-callback',
}

export const CLEVERTAP_EVENTS = {
  EVENT_PWA_HTP_VIDEO: "EVENT_PWA_HTP_VIDEO",
  EVENT_PWA_CLICK_BANNER: "EVENT_PWA_CLICK_BANNER",
  EVENT_PWA_PAGE_VIEW_HOME: "EVENT_PWA_PAGE_VIEW_HOME",
  EVENT_PWA_PHONE_NUMBER_SCREEN: "EVENT_PWA_PHONE_NUMBER_SCREEN",
  EVENT_PWA_PHONE_PROCEED: "EVENT_PWA_PHONE_PROCEED",
  EVENT_PWA_OTP_SCREEN: "EVENT_PWA_OTP_SCREEN",
  EVENT_PWA_ENTER_OTP: "EVENT_PWA_ENTER_OTP",
  EVENT_PWA_EXISTING_USER_PLAY_NOW: "EVENT_PWA_EXISTING_USER_PLAY_NOW",
  EVENT_PWA_REGISTER_TOURNAMENT: "EVENT_PWA_REGISTER_TOURNAMENT",
  EVENT_PWA_REGISTER_TOURNAMENT_NON_LOGGED_IN_USER: "EVENT_PWA_REGISTER_TOURNAMENT_NON_LOGGED_IN_USER",
  EVENT_PWA_CLICK_HELP: "EVENT_PWA_CLICK_HELP",
  EVENT_PWA_SIGN_UP: "EVENT_PWA_SIGN_UP",
  EVENT_PWA_SIGN_UP_SUCCESS: "EVENT_PWA_SIGN_UP_SUCCESS",
  EVENT_PWA_EXIT_TOURNAMENT: "EVENT_PWA_EXIT_TOURNAMENT",
  EVENT_PWA_WINNER_SCREEN: "EVENT_PWA_WINNER_SCREEN",
  EVENT_PWA_GAME_COMPLETED: "EVENT_PWA_GAME_COMPLETED",
  EVENT_PWA_WALLET_SCREEN: "EVENT_PWA_WALLET_SCREEN",
  EVENT_PWA_WALLET_WITHDRAW_CLICKED: "EVENT_PWA_WALLET_WITHDRAW_CLICKED",
  EVENT_PWA_WITHDRAW_SCREEN: "EVENT_PWA_WITHDRAW_SCREEN",
  EVENT_PWA_WITHDRAW_AMOUNT_ENTERED: "EVENT_PWA_WITHDRAW_AMOUNT_ENTERED",
  EVENT_PWA_WITHDRAW_CTA_CLICKED: "EVENT_PWA_WITHDRAW_CTA_CLICKED",
  EVENT_PWA_WITHDRAW_CONFIRM_BS_VIEW: "EVENT_PWA_WITHDRAW_CONFIRM_BS_VIEW",
  EVENT_PWA_WITHDRAW_CONFIRM_CLICKED: "EVENT_PWA_WITHDRAW_CONFIRM_CLICKED",
  EVENT_PWA_WITHDRAW_STATUS_SCREEN: "EVENT_PWA_WITHDRAW_STATUS_SCREEN",
  EVENT_PWA_WITHDRAW_SAVED_MODES_SCREEN: "EVENT_PWA_WITHDRAW_SAVED_MODES_SCREEN",
  EVENT_PWA_WITHDRAW_CHANGE_MODE_CLICKED: "EVENT_PWA_WITHDRAW_CHANGE_MODE_CLICKED",
  EVENT_PWA_WITHDRAW_ADD_MODE_START: "EVENT_PWA_WITHDRAW_ADD_MODE_START",
  EVENT_PWA_WITHDRAW_ADD_MODE_SUCCESS: "EVENT_PWA_WITHDRAW_ADD_MODE_SUCCESS",
  EVENT_PWA_WITHDRAW_ADD_MODE_FAILED: "EVENT_PWA_WITHDRAW_ADD_MODE_FAILED",
}




